import { PERCENT, percentValue, sameNumber, TOTAL_WORDS } from "./statedWeightTotal";

const CHOICE_TOTAL_WORDS = `(?:${TOTAL_WORDS}|sum(?!\\p{L}))\\s*[:=]?\\s*(?:på\\s+)?${PERCENT}`;
const BRACKETED_TOTAL = new RegExp(`\\s*\\(\\s*${CHOICE_TOTAL_WORDS}\\s*\\)`, "giu");
const TRAILING_TOTAL = new RegExp(`\\s*[,;–—-]\\s*${CHOICE_TOTAL_WORDS}\\s*\\.?\\s*$`, "iu");
const WEIGHT = new RegExp(`${PERCENT}(\\s+hver(?!\\p{L}))?`, "giu");
const NAME_SEPARATOR = /\s*,\s*|\s+og\s+/u;

const withoutTotals = (label: string): string => label.replace(BRACKETED_TOTAL, "").replace(TRAILING_TOTAL, "");

const namedWeightSum = (label: string): number => {
  let sum = 0;
  let previousEnd = 0;
  for (const match of label.matchAll(WEIGHT)) {
    const weight = percentValue(match[1]);
    const namesBefore = label
      .slice(previousEnd, match.index)
      .split(NAME_SEPARATOR)
      .filter((name) => name.trim()).length;
    sum += match[2] ? weight * Math.max(namesBefore, 1) : weight;
    previousEnd = match.index + match[0].length;
  }
  return sum;
};

export const withTrueWeightTotal = (label: string): string => {
  const sum = namedWeightSum(withoutTotals(label));
  const keepIfTrue = (stated: string, digits: string) => (sameNumber(percentValue(digits), sum) ? stated : "");
  return label.replace(BRACKETED_TOTAL, keepIfTrue).replace(TRAILING_TOTAL, keepIfTrue).trim();
};
